'use strict';

function CompanyOrderTypeService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/order-types/:orderTypeId', {}, {
    'update':  {
      method: 'PUT'
    }
  });
}

angular.module('dokiv')
  .factory('CompanyOrderTypeService', ['$resource', 'config', CompanyOrderTypeService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/order-type/CompanyOrderTypeService.js
// module id = 368
// module chunks = 0